import React, { useRef, useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import '../App.css'; // Add your styling if needed
import { useNavigate } from 'react-router-dom';
import TimeSeriesPlot from '../components/TimeSeriesPlot';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { io } from 'socket.io-client';

const DeviceManagerPage = () => {

    const [pictograms, setPictograms] = useState([]); 
    const [workspaceItems, setWorkspaceItems] = useState([]); 
    const [isPictogramListOpen, setIsPictogramListOpen] = useState(false); 
    const [selectedIcon, setSelectedIcon] = useState(null); 
    const [isSettingsVisible, setIsSettingsVisible] = useState(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false); 
    const [isDraggable, setIsDraggable] = useState(true);
    const [workspaceHeight, setWorkspaceHeight] = useState(0);
    const [textFields, setTextFields] = useState([]); 
    const [plotVisible, setPlotVisible] = useState(false);
    const [plotDeviceSN, setPlotDeviceSN] = useState(null);
    const [plotData, setPlotData] = useState([]);
    const [exportFormat, setExportFormat] = useState('xlsx');
    const [newWorkspaceName, setNewWorkspaceName] = useState('');
    //const [isDialogForWrkspaceNameOpen, setIsDialogForWrkspaceNameOpen] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [workspaceName, setWorkspaceName] = useState(sessionStorage.getItem('pageLoaded'));
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isWorkspaceName, setIsWorkspaceName] = useState(false);
    const [workspaces, setWorkspaces] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [isEditing, setIsEditing] = useState(false); // Track editing mode
    const [newEditedName, setNewEditedName] = useState(workspaceName || ''); 
    const [isWiFiPopupOpen, setIsWiFiPopupOpen] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    const navigate = useNavigate();

    let [fontSize, setFontSize] = useState(16);
    let [iconSize, setIconSize] = useState(100);
    let [gridStep, setGridStep] = useState(25);
    let x = `${gridStep}px`;

    const GRID_SIZE = gridStep || 25;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const startPosition = useRef({ x: 0, y: 0 }); // Хранение начальной позиции

    let role = localStorage.getItem('role');

    useEffect(() => {// Connect to the existing WebSocket server
        try {
            const socket = io(process.env.REACT_APP_API_URL);
            socket.on('connect', () => {
                console.log('WebSocket connected:', socket.id); // Log successful connection
            });
            socket.on('connect_error', (error) => {
                console.error('WebSocket connection error:', error); // Log connection errors
            });
            socket.on('disconnect', () => {
                console.log('WebSocket disconnected');
            });
            socket.on('newData', (data) => {// Listen for 'newData' events
                console.log('Received new data:', data);
                setWorkspaceItems((prevItems) => {
                    const updatedItems = [...prevItems];
                    let existingItem = {}; 
                    if (updatedItems.length > 0) {
                        existingItem = updatedItems.find(item => item.deviceSN === data.deviceSN);
                    }
                    if (JSON.stringify(existingItem) !== '{}' && existingItem !== undefined) {
                        existingItem.data[0].timestamp = data.timestamp;
                        existingItem.data[1].value = data.value;
                    } 
                    return updatedItems; 
                });
            });
            return () => {// Cleanup the connection on unmount
                socket.disconnect();
            };
        } catch (e) {
            console.log(e);
        }
    }, []);

    useEffect(() => {
        if (workspaceName && (workspaceName != "true")) {
            setWorkspaceName(workspaceName);
            loadWorkspace(workspaceName);
        } else {
            fetchLastWorkspace();
        }
    }, [workspaceName]);

    //useEffect(() => {
    //    if (workspaceName) {
    //        loadWorkspace(workspaceName);// You can also call loadWorkspace() here if needed:
    //    }
    //}, [workspaceName]);

    

    useEffect(() => {
        if (hasUnsavedChanges) {
            saveWorkspace(workspaceName);
        }
    }, [workspaceItems, textFields]);

    useEffect(() => {// Add beforeunload event to warn users about unsaved changes
        const handleBeforeUnload = (event) => {
            if (hasUnsavedChanges) {
                event.preventDefault();
                event.returnValue = ''; // Trigger the browser's warning dialog
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [hasUnsavedChanges]);

    const showPlot = (deviceSN) => {
        setPlotDeviceSN(deviceSN);
        setPlotVisible(true);
    };

    const closePlot = () => {
        setPlotVisible(false);
        setPlotDeviceSN(null);
        // setPlotData([]);// Clear out plot data if you want
    };

    const submitNewWorkspaceName = async (e) => {
        e.preventDefault();
        //loadWorkspace(newWorkspaceName); 
        
        const token = localStorage.getItem('token'); // Retrieve the token from localStorage
        if (!token) {
            console.error('Token not found in localStorage');
            return;
        }
        
        if (!newWorkspaceName.trim()) {// Validate that a workspace name is provided
            setError('Введите имя рабочего поля');
            return;
        }

        try {// Send a POST request to create a new workspace using fetch
            const response = await fetch(`${API_URL}/api/devices/newworkspace`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ newWorkspaceName: newWorkspaceName.trim()})
            });

            if (!response.ok) {// Check for errors in the response
                const errData = await response.json();
                setError('Такое имя уже существует.');
                return;
            }

            const data = await response.json();
            console.log('Рабочее поле создано:', data.workspace);

            setMessage('Рабочее поле создано успешно!');
            setError('');
            setWorkspaceName(workspaceName);

        } catch (err) {
            setError('Возникла ошибка. Рабочее поле не создано.');
            setMessage('');
        }
    };

    const addTextField = (newItem) => {
        const newId = getNextId(workspaceItems, textFields);
        const newTextField = {
            id: `${newId}`, // Unique ID
            position: { x: 100, y: 100 }, // Default position
            value: 'Поле для текста', // Default text
            type: 'textField',
            //iconSrc: newItem.iconSrc,
            propertiesSrc: newItem.propertiesSrc,
            editable: true,
        };
        setTextFields((prevFields) => [...prevFields, newTextField]);
    };

    const getNextId = (workspaceItems, textFields) => {
        if (workspaceItems.length === 0 && textFields.length === 0) {
            return 0; // If no items exist, start with ID 0
        }
        const maxIdWS = workspaceItems.reduce((max, item) => Math.max(max, parseInt(item.id, 10)), -1); // Max ID among workspace items
        const maxIdTF = textFields.reduce((max, item) => Math.max(max, parseInt(item.id, 10)), -1);
        return Math.max(maxIdWS, maxIdTF) + 1;
    };

     const loadWorkspace = async (workspaceName) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('No token found, user is not authenticated');

            const settingsResponse = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/settings`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`, // Attach the token
                },
            });

            const settingsData = await settingsResponse.json();
            if (!settingsData.workspaceName || settingsData.workspaceName == 'default') {
                fetchLastWorkspace();
            } else {
                //throw new Error('Failed to load workspace');
            }

            if (settingsData) {
                setFontSize(settingsData.settings.fontSize ?? 14);
                setIconSize(settingsData.settings.iconSize ?? 100);
                setGridStep(settingsData.settings.gridStep ?? 25);
            }

            const itemsResponse = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/items`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`, // Attach the token
                },
            });

            const data = await itemsResponse.json();
            const loadedIcons = data.filter((item) => item.type === "sensor" || item.type === "actuator");
            const loadedTextFields = data.filter((item) => item.type === 'textField');
            setWorkspaceItems(loadedIcons || []);
            setTextFields(loadedTextFields || []);
            setWorkspaceName(workspaceName);
            sessionStorage.setItem('pageLoaded', workspaceName);
            return data;
        } catch (error) {
            console.error('Error loading workspace:', error);
            return [];
        }
    };

    const deleteWorkspace = async (workspaceName) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('No token found, user is not authenticated');

            const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Failed to delete workspace');
            }

            setMessage(`Рабочее поле "${workspaceName}" удалено успешно.`);
            setWorkspaceName('');
            setWorkspaces((prev) =>
                prev.filter((ws) => ws.workspaceName !== workspaceName)
            );
        } catch (err) {
            setError(err.message);
        }
    };

    const handleShowPopup = async () => {
        setError('');
        setMessage('');
        const list = await loadWorkspaceList();
        setWorkspaces(list);
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    const fetchLastWorkspace = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('No token found, user is not authenticated');

            const response = await fetch(`${API_URL}/api/devices/workspace/last`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errorData = await response.json();
                return;
            }

            const workspace = await response.json();
            if ((workspace.workspaceName != '' || workspace.workspaceName != 'default') && workspace.workspaceName) {
                setWorkspaceName(workspace.workspaceName);
            }
        } catch (error) {
            console.error('Fetch error:', error);
        }
    };

    const loadWorkspaceList = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('No token found, user is not authenticated');

            const response = await fetch(`${API_URL}/api/devices/workspaces`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`, // Attach the token
                },
            });

            if (response.status == 404) {
                //setIsWorkspaceName(false);
                throw new Error('Файл не найден');
            } else if (response.status == 500) {
                throw new Error('Сервер не отвечает');
            }

            const workspaceList = await response.json();
            return workspaceList;
        } catch (error) {
            console.error('Error loading workspace:', error);
            return [];
        }
    };

    
    const toggleDraggable = () => {
        setIsDraggable(!isDraggable); // Toggle draggable state
    };

    const markChanges = () => {// Function to mark unsaved changes
        setHasUnsavedChanges(true);
    };

    

    const toggleSettingsVisibility = () => {
        setIsSettingsVisible(!isSettingsVisible);
        toggleDraggable();
    };

    //const calculateWorkspaceHeight = () => {
    //    if (workspaceItems.length === 0) {
    //        setWorkspaceHeight(0); // No icons, reset height
    //        return;
    //    }
    //    const maxHeight = Math.max(
    //        ...workspaceItems.map(
    //            (item) => item.position.y + 120 // Icon height (100px image + 20px text)
    //        )
    //    );
    //    setWorkspaceHeight(maxHeight + 20); // Add some padding
    //};

    //useEffect(() => {
    //    calculateWorkspaceHeight();
    //}, [workspaceItems]);

    const selectIcon = (icon) => {
        if (!icon) {
            console.error('No icon data provided for selection');
            return;
        }
        console.log(icon);
        //debugger;
        // Set the selected icon from the workspace data
        //if (icon.data && Array.isArray(icon.data) && icon.data[1] && icon.data[1].value !== undefined) {
        if (icon.type == 'sensor' || icon.type == 'actuator') {
            setSelectedIcon({
                id: icon.id,
                name: icon.name || '',
                description: icon.description || '',
                deviceModel: icon.deviceModel || '',
                type: icon.type || '',
                value: icon.data[1].value || '',
                alarm: icon.alarm || 'yes',
                deviceSN: icon.deviceSN || '',
                outputStates: icon.outputStates,
                operator: icon.operator,
                isAnalog: icon.isAnalog,
                battery: icon.battery || '',
            });
        } else if (icon.type == 'textField') {
            setSelectedIcon({
                id: icon.id,
                type: icon.type || '',
                value: icon.value || ''
            });
        } else {
            setSelectedIcon({
                id: icon.id,
                name: icon.name || '',
                description: icon.description || '',
                deviceModel: icon.deviceModel || '',
                type: icon.type || '',
                value: icon.value || '',
                alarm: icon.alarm || 'yes',
                deviceSN: icon.deviceSN || '',
                outputStates: icon.outputStates,
                operator: icon.operator,
                isAnalog: icon.isAnalog,
                battery: icon.battery || '',
            });
        }
    };

    const handleRightClick = async (event, oldIcon) => {
        event.preventDefault();
        const freshData = await loadWorkspace(workspaceName); // Re-fetch data from the backend
        const freshIcon = freshData.find(item => item.id === oldIcon.id);

        if (freshIcon) {
            selectIcon(freshIcon);
        } else {
            console.warn('Icon not found in fresh data', oldIcon.id);
            selectIcon(oldIcon); // fallback
        }
    };

    const fetchPictograms = async () => {// Fetch pictograms from the backend
        try {
            const response = await fetch(`${API_URL}/api/icons`); // Backend endpoint for icons
            if (!response.ok) throw new Error('Failed to fetch pictograms');
            const pictogramData = await response.json(); // Now an array of objects with file and deviceModel
            setPictograms(pictogramData);
        } catch (error) {
            console.error('Error fetching pictograms:', error);
        }
    };

    const openPictogramList = () => {
        fetchPictograms();
        setIsPictogramListOpen(true);
    };

    const saveWorkspace = async (workspaceName) => {// Save the current workspace to the backend
        const token = localStorage.getItem('token'); // Retrieve the token from localStorage
        if (!token) {
            console.error('Token not found in localStorage');
            return;
        }
        try {
            if ((!workspaceItems || workspaceItems.length === 0) && (!textFields || textFields.length === 0)) {
                setMessage('No workspace items to save.');
                return;
            }

            //if (!isWorkspaceName) {
            //    setIsDialogForWrkspaceNameOpen(true);
            //}

            const baseIcons = workspaceItems.map((item) => ({// Prepare icons to send
                workspaceName: workspaceName,
                id: item.id,
                position: item.position,
                iconSrc: item.iconSrc,
                propertiesSrc: item.propertiesSrc,
                type: 'sensor',
                deviceModel: item.deviceModel,
                outputStates: item.outputStates,
                operator: item.operator,
                isAnalog: item.isAnalog,
                battery: item.battery,
            }));

            const baseTextFields = textFields.map((field) => ({
                id: field.id,
                position: field.position,
                iconSrc: field.iconSrc,
                propertiesSrc: field.propertiesSrc,
                value: field.value,
                type: 'textField',
                //deviceModel: field.deviceModel,
            }));

            const combinedItems = [...baseIcons, ...baseTextFields];

            const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(combinedItems),
            });

            if (!response.ok) throw new Error('Failed to save workspace');
            console.log('Workspace saved successfully:', combinedItems);
            setHasUnsavedChanges(false); // Reset unsaved changes
        } catch (error) {
            console.error('Error saving workspace:', error);
        }
    };

    const getProperties = async (pictogramPath, deviceModel, event) => {
        const pictogramName = deviceModel;
        const propertiesPath = `/properties/${deviceModel}.json`;
        
        let properties = {};
        try {
            const response = await fetch(propertiesPath);
            if (!response.ok) {
                console.error(`Failed to load properties from ${propertiesPath}`);
            } else {
                properties = await response.json();
            }
        } catch (error) {
            console.error(`Error fetching properties: ${error}`);
        }

        const snappedPosition = snapToGrid(0, 300);
        const newId = getNextId(workspaceItems, textFields);
        const newItem = {
            ...properties,
            id: `${newId}`, // Generate a unique ID
            position: snappedPosition,
            iconSrc: pictogramPath,
            propertiesSrc: propertiesPath,
            deviceModel: deviceModel,
            value: '',
        };
        newItem.data = [{}, {}];
        newItem.data[0] = { timestamp: Date.now() };
        return newItem;
    };

    const addToWorkspace = async (pictogramPath, deviceModel, event) => {
        const newItem = await getProperties(pictogramPath, deviceModel, event);
        if (newItem.type === "textField") {
            addTextField(newItem);
        } else {
            setWorkspaceItems((prevItems) => {
                return [...prevItems, newItem];
            });
        }
        markChanges(); // Mark changes when a new item is added
    };

    const snapToGrid = (x, y) => {
        return {
            x: Math.round(x / GRID_SIZE) * GRID_SIZE,
            y: Math.round(y / GRID_SIZE) * GRID_SIZE,
        };
    };

    const handleDragStop = (item, data) => {
        let snappedPosition = snapToGrid(data.x, data.y);
        setWorkspaceItems((prevItems) => {
            const updatedItems = prevItems.map((workspaceItem) =>
                workspaceItem.id === item.id
                    ? { ...workspaceItem, position: snappedPosition }
                    : workspaceItem
            );
            return updatedItems;
        });
        setTimeout(() => {// Use a timeout to ensure the state update has propagated
            saveWorkspace(workspaceName);
        }, 0);
    };

    const deleteFromWorkspace = async (item) => {
        try {
            const confirmed = window.confirm("Этот элемент будет удален. Вы согласны?");
            if (confirmed) {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('No token found, user is not authenticated');
                }
                const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/item`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ itemId: item.id, type: item.type }),
                });

                if (!response.ok) {
                    throw new Error('Failed to delete workspace item');
                }

                if (item.type === 'sensor' || item.type === 'actuator') {
                    setWorkspaceItems((prevItems) => prevItems.filter((i) => i.id !== item.id));
                } else if (item.type === 'textField') {
                    setTextFields((prevFields) => prevFields.filter((f) => f.id !== item.id));
                }
            }
        } catch (error) {
            console.error('Error deleting workspace item:', error);
        }
    };

    const saveProperties = async (updatedIcon) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('No token found, user is not authenticated');
            }
            const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/item/properties`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    itemId: updatedIcon.id,
                    updatedProperties: updatedIcon, // Save only the updated properties
                }),
            });
            if (!response.ok) {
                throw new Error('Failed to save updated properties');
            }
            const savedData = await response.json();

            setTextFields((prevFields) =>
                prevFields.map((field) =>
                    field.id === savedData.item.id ? { ...field, value: savedData.item.value } : field
                )
            );

            const handleUpdate = (updatedIcon, savedData) => {
                console.log("data:", savedData);
                if (!savedData) {
                    console.error("Error: data is undefined");
                    return;
                }
                setWorkspaceItems((prevItems) =>
                    prevItems.map((item) =>
                        item.id === updatedIcon.id ? { ...item, ...savedData.item } : item
                    )
                );
            };
           
            setSelectedIcon(savedData.item);
            setSelectedIcon(null); // Close the property page
        } catch (error) {
            console.error('Error saving properties:', error);
            alert('Failed to save properties.');
        }
    };

    // Handle double-click to enable editing
    const handleDoubleClick = () => {
        setIsEditing(true);
        setNewEditedName(workspaceName || ''); // Reset the input value to the current workspace name
    };

    // Handle input changes while editing
    const handleInputChange = (e) => {
        setNewEditedName(e.target.value); // Update the state with the new value
    };

    // Save the updated workspace name when Enter is pressed
    const handleSaveEditedName = async () => {
        if (!newEditedName.trim()) {
            alert('Workspace name cannot be empty.');
            setIsEditing(false); // Exit editing mode
            return;
        }
        const token = localStorage.getItem('token'); // Retrieve the token from localStorage
        if (!token) {
            console.error('Token not found in localStorage');
            return;
        }

        try {
            const response = await fetch(`${API_URL}/api/devices/workspace/${workspaceName}/nameupdate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ workspaceName: workspaceName, newEditedName: newEditedName }),
            });
            if (!response.ok) {
                const errorData = await response.json(); // Parse error message from backend
                console.error('Backend error:', errorData.message || 'Unknown error');
                alert('Failed to update workspace name. Please try again.');
                setIsEditing(false); // Exit editing mode on failure
                return;
            }

            const data = await response.json(); // Parse success response
            console.log('Workspace name updated successfully:', data.message);

            // Update the workspace name in the parent component or local state
            setWorkspaceName(newEditedName);
            // Exit editing mode
            setIsEditing(false);
        } catch (error) {
            console.error('Error updating workspace name:', error);
            alert('Failed to update workspace name. Please try again.');
            setIsEditing(false); // Exit editing mode on failure
        }
    };

    // Handle Enter key press
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSaveEditedName();
        }
    };

    // Cancel editing when the input loses focus
    const handleBlur = () => {
        setIsEditing(false); // Exit editing mode
        setNewEditedName(workspaceName || ''); // Reset the input value
    };

    const connectToWiFi = (selectedIcon) => {
        var x = selectedIcon;
        openWiFiPopup();

    }

    const openWiFiPopup = () => setIsWiFiPopupOpen(true);
    const closeWiFiPopup = () => setIsWiFiPopupOpen(false);




    const renderDeviceProperties = (properties) => {
        const friendlyNames = {
            name: "Имя",
            description: "Описание",
            deviceModel: "Марка устройства",
            type: "Тип",
            value: "Значение",
            alarm: "Подавать сигнал?",
            deviceSN: "Серийный номер",
            battery: "Тип батарейки"
        };

        return Object.entries(properties)
            .filter(([key]) => ['name', 'description', 'deviceModel', 'type', 'value', 'alarm', 'battery', 'deviceSN'].includes(key))
            .map(([key, value]) => {
                const isEditable = ['name', 'description', 'alarm', 'value', 'deviceSN'].includes(key);
                const friendlyKey = friendlyNames[key] || key;
                return (
                    <div key={key} style={{ marginBottom: '8px' }}>
                        <label style={{ fontWeight: 'bold' }}>{friendlyKey}:</label>
                        {isEditable ? (
                            <input
                                type="text"
                                value={value}
                                onChange={(e) =>
                                    setSelectedIcon((prev) => ({
                                        ...prev,
                                        [key]: e.target.value,
                                    }))
                                }
                                style={{
                                    width: '100%',
                                    padding: '5px',
                                    marginTop: '4px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                    width: '100%',
                                    padding: '5px',
                                    marginTop: '4px',
                                    border: '1px solid #eee',
                                    borderRadius: '4px',
                                    background: '#f9f9f9',
                                }}
                            >
                                {typeof value === 'object'
                                    ? JSON.stringify(value, null, 2)
                                    : value}
                            </div>
                        )}
                    </div>
                );
            });
    };

    const renderTextFieldProperties = (textFields) => {
        return Object.entries(textFields).filter(([key]) => ['value'].includes(key))
            .map(([key, value]) => {
            return (
                <div key={key} style={{ marginBottom: '8px' }}>
                    <input
                        type="text"
                        value={value}
                        onChange={(e) => {
                            setSelectedIcon((prev) => ({
                                ...prev,
                                [key]: e.target.value,
                            }));
                        }}
                        style={{
                            width: '100%',
                            padding: '5px',
                            marginTop: '4px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                    />
                </div>
            );
        });
    };
   
    const handleDataLoaded = (data) => {// We'll assume your TimeSeriesPlot can pass data back via onDataLoaded
        setPlotData(data);
    };

    const createCSV = (data) => {// Helper functions to build file content in various formats
        if (!Array.isArray(data)) {
            return '';
        }
        if (data.length === 0) return '';

        const headers = Object.keys(data[0]);// Gather headers from the first object
        const csvRows = [];// Build CSV
        csvRows.push(headers.join(',')); // header row
        for (const row of data) {
            const values = headers.map(header => row[header]);
            csvRows.push(values.join(','));
        }
        return csvRows.join('\n');
    };

    const createTXT = (data) => {// Ensure data is an array
        if (!Array.isArray(data)) return '';
        return data.map(item =>// Map each item to a formatted string and join them with new lines
            Object.values(item).join(',')
        ).join('\n');
    };

    const createJSON = (data) => {
        return JSON.stringify(data, null, 2);
    };

    const createXML = (data) => {
        if (!Array.isArray(data)) return '';
        const xmlRows = data.map(item => {
            const xmlFields = Object.entries(item)
                .map(([key, value]) => `<${key}>${value}</${key}>`)
                .join('');
            return `<row>${xmlFields}</row>`;
        });
        return `<?xml version="1.0" encoding="UTF-8"?>\n<data>\n${xmlRows.join('\n')}\n</data>`;
    };

    const downloadFile = (content, filename, type) => {// We'll create a single function to handle the actual download
        const blob = new Blob([content], { type });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        URL.revokeObjectURL(url);
    };

    const handleExport = () => {
        if (!plotData || plotData.length === 0) {
            alert('Нет данных для экспорта или данные не загружены.');
            return;
        }
        let content = '';
        let fileExtension = '';
        let mimeType = '';

        switch (exportFormat) {
            case 'xlsx':// Создание XLSX файла с использованием SheetJS
                const worksheet = XLSX.utils.json_to_sheet(plotData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
                const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const blobXLSX = new Blob([wbout], { type: 'application/octet-stream' });
                saveAs(blobXLSX, 'plot_data.xlsx');
                break;
            case 'csv':
                content = createCSV(plotData);
                fileExtension = 'csv';
                mimeType = 'text/csv';
                downloadFile(content, `plot_data.${fileExtension}`, mimeType);
                break;
            case 'txt':
                content = createTXT(plotData);
                fileExtension = 'txt';
                mimeType = 'text/plain';
                downloadFile(content, `plot_data.${fileExtension}`, mimeType);
                break;
            case 'json':
                content = createJSON(plotData);
                fileExtension = 'json';
                mimeType = 'application/json';
                downloadFile(content, `plot_data.${fileExtension}`, mimeType);
                break;
            case 'xml':
                content = createXML(plotData);
                fileExtension = 'xml';
                mimeType = 'application/xml';
                downloadFile(content, `plot_data.${fileExtension}`, mimeType);
                break;
            default:
                alert('Неподдерживаемый формат экспорта.');
        }
    };

    return (
        <div className="device-manager-page">
            <div
                style={{
                    display: 'flex', // Use Flexbox for horizontal alignment
                    alignItems: 'center', // Align items vertically in the center
                    position: 'relative', // Ensure the button's absolute positioning works correctly
                    backgroundColor: '#f0f0f0',
                    padding: '0px',
                    width: '100%',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
            >
                {/* Gear Button */}
                <button
                    onClick={() => {
                        toggleSettingsVisibility();
                        setIsPictogramListOpen(false);
                    }}
                    style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '5px',
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        boxShadow: '0.2em 0.2em 5px rgba(10, 10, 10, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
                >
                    <img
                        src="/pictures/HamburgerIcon.png"
                        alt="HamburgerIcon"
                        style={{ width: '30px', height: '30px' }}
                    />
                </button>

                {/* Header Content */}
                <div style={{flexGrow: 1,}}>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    {message && <p style={{ color: 'green', margin: 0 }}>{message}</p>}


                    {isEditing ? (
                        <input
                            type="text"
                            value={newEditedName}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyPress}
                            onBlur={handleBlur}
                            autoFocus // Automatically focus the input field
                            style={{ fontSize: '1rem', padding: '0.25rem', width: 'fit-content' }}
                        />
                    ) : (
                        <h3
                            style={{ margin: 0, cursor: 'pointer' }}
                            onDoubleClick={handleDoubleClick}
                        >
                            {workspaceName}
                        </h3>
                    )}




                </div>
            </div>

            {/* Settings Buttons */}
            {isSettingsVisible && (
                <div
                    style={{
                        position: 'fixed',
                        left: '0',
                        bottom: '0',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        padding: '10px',
                        paddingBottom: `calc(20px + env(safe-area-inset-bottom))`,
                        backgroundColor: '#f9f9f9',
                        borderTop: '1px solid #ddd',
                        boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)',
                        zIndex: 11,
                        width: 'calc(100% - 20px)',
                    }}
                >

                    {showForm && (//New workspace creation form 
                        <div
                            style={{
                                position: 'fixed',
                                top: '20px', // Adjust the distance from the top as needed
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: '#fff',
                                padding: '20px',
                                borderRadius: '8px',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                zIndex: 1000, // Ensure it appears above other elements
                            }}
                        >
                            <form onSubmit={submitNewWorkspaceName}>
                                <input
                                    type="text"
                                    placeholder="Введите новое имя"
                                    value={newWorkspaceName}
                                    onChange={(e) => {
                                        setNewWorkspaceName(e.target.value);
                                    }} 
                                />
                                <div style={{ marginTop: '10px' }}>
                                    <button type="submit">Создать</button>
                                </div>
                                {/* "Close" button to hide the form */}
                                <div style={{ marginTop: '10px' }}>
                                    <button type="button" onClick={() => {
                                        setShowForm(false);
                                        setMessage('');
                                        setError('');
                                        if (newWorkspaceName) {
                                            loadWorkspace(newWorkspaceName);
                                            setWorkspaceName(newWorkspaceName);
                                        }
                                    }}>
                                        Закрыть
                                    </button>
                                </div>

                            </form>
                            <div style={{ marginTop: '10px' }}>
                                {message && <p style={{ color: 'green', margin: 0 }}>{message}</p>}
                                {error && <p style={{ color: 'red', margin: 0 }}>{error}</p>}
                            </div>
                        </div>
                    )}

                    {/* Add Button Открыть*/}
                    {/* Button to open the popup with the workspace list */}
                    <button
                        onClick= {handleShowPopup}
                        style={{
                            flex: '1',
                            margin: '0 5px',
                            padding: '12px 15px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#fff',
                            backgroundColor: '#008080',
                            border: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#008080')}
                    >
                        Открыть
                    </button>

                    {/* Popup modal to display workspace list */}
                    {showPopup && (
                        <div
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', // Overlay background
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 1000,
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: '#fff',
                                    padding: '20px',
                                    borderRadius: '8px',
                                    maxHeight: '80vh',
                                    overflowY: 'auto',
                                    width: '90%',
                                    maxWidth: '600px',
                                }}
                            >
                                <h2>Список рабочих полей</h2>
                                {workspaces.length > 0 ? (
                                    workspaces.map((workspace, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                border: '1px solid #ccc',
                                                padding: '10px',
                                                margin: '10px 0',
                                                borderRadius: '4px',
                                            }}
                                        >
                                            <p>
                                                <strong>Имя:</strong> {workspace.workspaceName}
                                            </p>
                                            <p>
                                                <strong>Дата создания:</strong>{' '}
                                                {new Date(workspace.updatedAt).toLocaleString('ru-RU')}
                                            </p>
                                            <button
                                                onClick={() => {
                                                    loadWorkspace(workspace.workspaceName);
                                                    setWorkspaceName(workspace.workspaceName);
                                                    handleClosePopup();
                                                }}
                                                style={{
                                                    marginRight: '10px',
                                                    padding: '5px 10px',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                Открыть
                                            </button>
                                            <button
                                                onClick={() => {
                                                    if (window.confirm(`Вы уверены, что хотите удалить "${workspace.workspaceName}"?`)) {
                                                        deleteWorkspace(workspace.workspaceName);
                                                    }
                                                }}
                                                style={{
                                                    padding: '5px 10px',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#e74c3c',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                }}
                                            >
                                                Удалить
                                            </button>
                                        </div>
                                    ))
                                ) : (
                                    <p>Не найдено ни одного рабочего поля.</p>
                                )}
                                <button
                                    onClick={handleClosePopup}
                                    style={{
                                        marginTop: '15px',
                                        padding: '10px 15px',
                                        backgroundColor: '#008080',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        position: 'sticky',  // Makes the button sticky
                                        bottom: 0,  // Ensures it stays at the bottom
                                        width: '100%',
                                    }}
                                >
                                    Закрыть
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Add Button Создать*/}
                    <button
                        onClick={() => {
                            
                            setShowForm(true);
                            setMessage('');
                            setError('');
                        }}
                        style={{
                            flex: '1',
                            margin: '0 5px',
                            padding: '12px 15px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#fff',
                            backgroundColor: '#008080',
                            border: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#008080')}
                    >
                        Создать
                    </button>

                    <button
                        onClick={() => navigate(`/choose-scenario/${workspaceName}`)}
                        style={{
                            flex: '1',
                            margin: '0 5px',
                            padding: '12px 15px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#fff',
                            backgroundColor: '#008080',
                            border: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#008080')}
                    >
                        Показать сценарии
                    </button>

                    <button
                        onClick={() => navigate(`/add-scenario/${workspaceName}`)}
                        style={{
                            flex: '1',
                            margin: '0 5px',
                            padding: '12px 15px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#fff',
                            backgroundColor: '#008080',
                            border: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#008080')}
                    >
                        Добавить новый сценарий
                    </button>

                    {/* Add Pictogram Button */}
                    <button
                        onClick={() => {
                            openPictogramList();
                        }}
                        style={{
                            flex: '1',
                            margin: '0 5px',
                            padding: '12px 15px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#fff',
                            backgroundColor: '#008080',
                            border: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#008080')}
                    >
                        Добавить пиктограму
                    </button>

                    {/* Save Workspace Button */}
                    <button
                        onClick={() => {
                            saveWorkspace(workspaceName);
                        }}
                        style={{
                            flex: '1',
                            margin: '0 5px',
                            padding: '12px 15px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#fff',
                            backgroundColor: '#28a745',
                            border: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#218838')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')}
                    >
                        Сохранить всё
                    </button>

                    {/* Connect WiFi Button */}
                    <button
                        onClick={() => navigate('/blewifi-page')}
                        style={{
                            flex: '1',
                            margin: '0 5px',
                            padding: '12px 15px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#fff',
                            backgroundColor: '#28a745',
                            border: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#008080')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')}
                    >
                        Подключить WiFi
                    </button>

                    {/* Settings Button */}
                    <button
                        //onClick={() => navigate('/settings')}
                        onClick={() => navigate(`/settings/${workspaceName}`)}
                        style={{
                            flex: '1',
                            margin: '0 5px',
                            padding: '12px 15px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#fff',
                            backgroundColor: '#28a745',
                            border: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#008080')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#28a745')}
                    >
                        Настройки
                    </button>
                </div>
            )}

            {/* Pictogram List Modal */}
            {isPictogramListOpen && (
                <div className="pictogram-modal">
                    <h2>Выберите что нужно</h2>
                    <div
                        className="pictogram-list"
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '10px',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                        }}
                    >
                        {pictograms.map((pictogram, index) => (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    addToWorkspace(`/icons/${pictogram.iconSrc}`, pictogram.deviceModel, event);
                                }}
                            >
                                <img
                                    src={`${API_URL}/icons/${pictogram.iconSrc}`}
                                    alt={pictogram.deviceModel}
                                    style={{ width: '50px', height: '50px', marginBottom: '5px' }}
                                />
                                <span style={{ fontSize: '12px', color: '#333' }}>
                                    {pictogram.deviceModel}
                                </span>
                            </div>
                        ))}
                    </div>
                    <button onClick={() => setIsPictogramListOpen(false)}>Закрыть</button>
                </div>
            )}


            {/* Workspace */}
            <div
                id="workspace-container"
                style={{
                    marginTop: '0px',
                    padding: '10px',
                    position: 'relative',
                    minHeight: `calc(100vh - 200px)`,
                    width: '100%',
                    //height: `${Math.max(workspaceHeight, window.innerHeight)}px`,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    boxSizing: 'border-box',
                    //paddingBottom: `calc(160px + env(safe-area-inset-bottom))`,
                    //border: '2px solid #ff0000'
                }}
            >
                {textFields.map((field) => (
                    <Draggable
                        key={field.id}
                        position={field.position}
                        disabled={isDraggable}
                        onStop={(e, data) => {
                            setTextFields((prevFields) =>
                                prevFields.map((f) =>
                                    f.id === field.id ? { ...f, position: { x: data.x, y: data.y } } : f
                                )
                            );
                            field.position.x = data.x;
                            field.position.y = data.y;
                            handleDragStop(field, data);
                        }}
                    >
                        <div
                            onContextMenu={(event) => {
                                if (isSettingsVisible) {
                                    event.preventDefault();
                                    deleteFromWorkspace(field);
                                } else {
                                    handleRightClick(event, field);
                                }
                            }}
                            style={{
                                position: 'absolute',
                                padding: '5px',
                                backgroundColor: '#ffffff',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                cursor: 'move',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                minWidth: '250px',
                                userSelect: 'none',
                            }}
                            onTouchStart={(event) => {
                                if (isTouchDevice) {
                                    const currentTime = new Date().getTime();
                                    const timeDifference = currentTime - (startPosition.current.lastTap || 0);
                                    startPosition.current = { lastTap: currentTime };
                                    event.preventDefault();
                                    event.stopPropagation();
                                    if (timeDifference < 300 && timeDifference > 0) {
                                        if (!isSettingsVisible) {
                                            handleRightClick(event, field);
                                        } else {
                                            deleteFromWorkspace(field);
                                        }
                                    }
                                }
                            }}
                        >
                            <input
                                type="text"
                                value={field.value}
                                onChange={(e) => {
                                    if (!isSettingsVisible) {
                                        const newText = e.target.value;
                                        setTextFields((prevFields) =>
                                            prevFields.map((f) =>
                                                f.id === field.id ? { ...f, value: newText } : f
                                            )
                                        );
                                    }
                                }}
                                style={{
                                    border: 'none',
                                    outline: 'none',
                                    width: '100%',
                                    fontSize: `${parseInt('10px', 10) + fontSize}px`,
                                    fontWeight: 'bold',
                                    padding: '5px',
                                    borderRadius: '5px',
                                    color: '#008080',
                                    backgroundColor: 'transparent',
                                    textAlign: 'center',
                                    width: `${Math.max(field.value.length, 1)}ch`,
                                    minWidth: '250px',
                                }}
                                readOnly={!isSettingsVisible}
                                onContextMenu={(e) => e.preventDefault()}
                                onTouchStart={(e) => e.preventDefault()}
                            />
                        </div>
                    </Draggable>
                ))}

                {workspaceItems.map((item) => (
                    <Draggable
                        key={item.id}
                        position={{ x: item.position.x, y: item.position.y }}
                        onStop={(e, data) => {
                            item.position.x = data.x;
                            item.position.y = data.y;
                            handleDragStop(item, data);
                        }}
                        disabled={isDraggable}
                    >
                        <div id='testselector'
                            onContextMenu={(event) => {
                                if (!isSettingsVisible) {
                                    handleRightClick(event, item);
                                } else {
                                    event.preventDefault();
                                    deleteFromWorkspace(item);
                                }
                            }}
                            style={{
                                position: 'absolute',
                                width: '100px',
                                height: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'left',
                                justifyContent: 'left',
                            }}
                            onTouchStart={(event) => {
                                if (isTouchDevice) {
                                    const currentTime = new Date().getTime();
                                    const timeDifference = currentTime - (startPosition.current.lastTap || 0);
                                    startPosition.current = { currentTime };
                                    event.preventDefault();
                                    event.stopPropagation();
                                    if (timeDifference < 300 && timeDifference > 0) {
                                        if (!isSettingsVisible) {
                                            handleRightClick(event, item);
                                        } else {
                                            deleteFromWorkspace(item);
                                        }
                                    }
                                }
                            }}
                        >
                            {/* Icon Image */}
                            <img
                                src={`${API_URL}/${item.iconSrc}`} 
                                alt={`Item ${item.id}`}
                                style={{
                                    width: `${iconSize}px`,height: `${iconSize}px`,cursor: 'grab',border: '1px solid grey',
                                    borderRadius: '10px',boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)',
                                }}
                            />
                            {/* Icon Name / Data */}
                            <p style={{ margin: '4px 0', fontSize: `${fontSize}px` }}>
                                {item.name}:{" "}{item.description}{" "} {item.deviceModel}{" "}
                                 {item.data[1].value == 1 ? 'Открыто' : 'Закрыто'}
                            </p>
                        </div>
                    </Draggable>
                ))}
            </div>

            {selectedIcon && (
                <div
                    style={{
                        position: 'absolute',top: '20px',left: '50%',transform: 'translateX(-50%)',width: '400px',
                        border: '1px solid #ccc',padding: '20px',background: '#fff',boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        zIndex: 1000,borderRadius: '8px',
                    }}
                >
                    <h3>{selectedIcon.type === 'textField' ? 'Текст' : 'Свойства'}</h3>
                    <div style={{ marginBottom: '10px' }}>
                        {selectedIcon.type === 'textField'
                            ? renderTextFieldProperties(selectedIcon)
                            : renderDeviceProperties(selectedIcon)}
                    </div>
                    {selectedIcon.type === 'textField' ? (
                        <>
                            <button
                                onClick={() => saveProperties(selectedIcon)}
                                style={{
                                    marginTop: '10px', padding: '5px 10px', background: '#008080', color: '#fff',
                                    border: 'none', cursor: 'pointer', borderRadius: '4px',
                                }}
                            >
                                Сохранить
                            </button>
                            <button
                                onClick={() => setSelectedIcon(null)}
                                style={{
                                    marginLeft: '10px', padding: '5px 10px', background: '#f44336', color: '#fff',
                                    border: 'none', cursor: 'pointer', borderRadius: '4px',
                                }}
                            >
                                Закрыть
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                onClick={() => saveProperties(selectedIcon)}
                                style={{
                                    marginTop: '10px', padding: '5px 10px', background: '#008080', color: '#fff',
                                    border: 'none', cursor: 'pointer', borderRadius: '4px',
                                }}
                            >
                                Сохранить
                            </button>
                            <button
                                onClick={() => setSelectedIcon(null)}
                                style={{
                                    marginLeft: '10px', padding: '5px 10px', background: '#f44336', color: '#fff',
                                    border: 'none', cursor: 'pointer', borderRadius: '4px',
                                }}
                            >
                                Закрыть
                            </button>
                            <button
                                onClick={() => showPlot(selectedIcon.deviceSN)}
                                style={{
                                    marginLeft: '10px', padding: '5px 10px', background: '#4CAF50', color: '#fff',
                                    border: 'none', cursor: 'pointer', borderRadius: '4px',
                                }}
                            >
                                Показать график
                            </button>
                            <button
                                onClick={() => connectToWiFi(selectedIcon)}
                                style={{
                                    marginLeft: '10px', padding: '5px 10px', background: '#4CAF50', color: '#fff',
                                    border: 'none', cursor: 'pointer', borderRadius: '4px',
                                }}
                            >
                                Подключить к WiFi
                            </button>
                        </>
                    )}
                </div>
            )}

            {/* Plot Modal */}
            {plotVisible && (
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        padding: '20px',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        zIndex: 1100,
                        borderRadius: '8px',
                    }}
                >
                    {/* Chart at the top */}
                    <TimeSeriesPlot
                        serialNumber={plotDeviceSN}
                        stepped={true}
                        tension={0}
                        // We add a new prop/callback so that the chart can pass data back to us
                        onDataLoaded={handleDataLoaded}
                    />

                    {/* Choose export format + Export button */}
                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        <label style={{ marginRight: '10px' }}>Формат экспорта:</label>
                        <select
                            value={exportFormat}
                            onChange={(e) => setExportFormat(e.target.value)}
                            style={{
                                padding: '5px',
                                marginRight: '10px',
                            }}
                        >
                            <option value="xlsx">XLSX</option>
                            <option value="csv">CSV</option>
                            <option value="txt">TXT</option>
                            <option value="json">JSON</option>
                            <option value="xml">XML</option>
                        </select>
                        <button
                            onClick={handleExport}
                            style={{
                                padding: '5px 10px',
                                background: '#008080',
                                color: '#fff',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                                marginRight: '10px',
                            }}
                        >
                            Экспорт
                        </button>
                        <button
                            onClick={closePlot}
                            style={{
                                padding: '5px 10px',
                                background: '#f44336',
                                color: '#fff',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '4px',
                            }}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>
            )}

            {/* WiFiPopup Implementation */}
            {isWiFiPopupOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent overlay
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                    onClick={closeWiFiPopup} // Close popup when clicking outside
                >
                    <div
                        style={{
                            backgroundColor: 'white',
                            padding: '20px',
                            borderRadius: '8px',
                            maxWidth: '600px',
                            width: '90%',
                            position: 'relative', // For close button positioning
                        }}
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                    >
                        <button
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '20px',
                            }}
                            onClick={closeWiFiPopup}
                        >
                            &times;
                        </button>
                        <BleWifiPage onClose={closeWiFiPopup} />
                    </div>
                </div>
            )}
        </div>
    );
};

function BleWifiPage({ onClose }) {
    const chromeMatch = navigator.userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
    if (chromeMatch) {
        const chromeVersion = parseInt(chromeMatch[1], 10); // Capture the version
        if (chromeVersion < 45) {
            ChromeSamples.setStatus('Нужно использовать Google Chrome версии не ниже 45.');
        }
    }

    let characteristic;
    let timeoutIDBLE;

    const [ssid, setSsid] = useState('Boteyes');
    const [password, setPassword] = useState('b0teyest@b');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [website, setWebsite] = useState('195.161.114.31'); // Initial value for the website field
    const [isWebsiteEditable, setIsWebsiteEditable] = useState(false);

    const handleSsidChange = (e) => setSsid(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);
    const handleWebsiteChange = (e) => setWebsite(e.target.value);
    const toggleWebsiteEditability = () => setIsWebsiteEditable(!isWebsiteEditable); // Toggle the editable state
    const togglePasswordVisibility = () => setIsPasswordVisible(!isPasswordVisible);

    const log = (...args) => {
        const line = args.map((arg) => (typeof arg === 'string' ? arg : JSON.stringify(arg))).join(' ');
        document.querySelector('#log').textContent += line + '\n';
    };

    useEffect(() => {
        let isBluetoothAvailableLogged = false; // Track if the availability message has been logged
        try {
            navigator.bluetooth.getAvailability()
                .then(isBluetoothAvailable => {
                    if (!isBluetoothAvailableLogged) {
                        log(`> Bluetooth ${isBluetoothAvailable ? 'доступен' : 'недоступен'}`);
                        isBluetoothAvailableLogged = true; // Prevent duplicate logging
                    }
                });
            if ('onavailabilitychanged' in navigator.bluetooth) {
                navigator.bluetooth.addEventListener('availabilitychanged', (event) => {
                    log(`> Bluetooth ${event.value ? 'доступен' : 'недоступен'}`);
                });
            }
        } catch (e) {
            log("Ваш гаджет не поддерживает Bluetooth Low Energy");
        }
    }, []); // Run only once when the component mounts


    let serviceUuid = '0xFFE0';
    serviceUuid = parseInt(serviceUuid);
    let characteristicUuid = '0xFFE1';
    characteristicUuid = parseInt(characteristicUuid);
    let options = {
        filters: [{
            namePrefix: ["RealIoT"]
        }],
        optionalServices: [0xFFE0]
    }

    async function connectButton() {
        try {
            const device = await navigator.bluetooth.requestDevice(options);
            device.addEventListener('gattserverdisconnected', onDisconnected);
            const server = await device.gatt.connect();
            log('Жду ответа...');
            const service = await server.getPrimaryService(serviceUuid);
            characteristic = await service.getCharacteristic(characteristicUuid);
            characteristic.addEventListener('characteristicvaluechanged', handleNotification);
            await characteristic.startNotifications();
            log('Устанавливаем соединение');
            clearInterval(timeoutIDBLE);
        } catch (error) {
            if (!(error.message.includes('User cancelled'))) {
                log('', error.message || error);
            }
        }
    }

    function onDisconnected(event) {
        log('> Bluetooth устройство отсоединено');
    }

    function handleNotification(event) {
        try {
            const value = event.target.value;
            if (value.byteLength >= 2) {
                const decoder = new TextDecoder('utf-8');
                const decodedString = decoder.decode(value);
                if (decodedString != '') {
                    log(`Ответ устройства: ${decodedString}`);
                }
            } else {
                //log('DataView does not contain enough bytes for a 16-bit value.');
            }
        } catch (error) {
            log(error.message);
        }

    }

    function sendData() {
        try {
            let ssidValue = "";
            let ssid = document.getElementById("ssid").value;
            if (ssid == "") {
                log(`Введите имя точки доступа WiFi`);
                return;
            } else {
                ssidValue = ssid + "\r";
            }

            let passwValue = "";
            let passw = document.getElementById("passw").value;
            if (passw == "") {
                log(`Введите пароль WiFi`);
                return;
            } else {
                passwValue = passw + "\r";
            }

            let websiteValue = "";
            let website = document.getElementById("website").value;
            if (website == "") {
                log(`Введите адрес вебсайта`);
                return;
            } else {
                websiteValue = "mqtt://" + website + "\r";
            }
            let concatenatedString = "1," + ssidValue + "," + passwValue + "," + websiteValue;
            let encoder = new TextEncoder('utf-8');
            let encodedString = encoder.encode(concatenatedString);
            if (!characteristic) {
                log('Bluetooth Low Energy не подключен. Нажмите "Подключиться".'); return;
            } else {
                characteristic.writeValueWithResponse(encodedString);
            }
        } catch (error) {
            log(error.message);
        }
    }

    const closewifipopup = () => {
        onClose();
    }
   


    return (
        <div>
            <h2>Подключение IoT устройства к сети WiFi</h2>
            <p>
                Для подключения IoT устройства к WiFi надо подключиться к нему через
                Bluetooth Low Energy (BLE), ввести здесь (см. ниже) имя точки доступа и пароль и отправить их в IoT устройство. Чтобы это сделать, выполните следующее:</p>
            <p>
                1. Включите Bluetooth на мобильном устройстве. Если вы используете
                настольный компьютер без встроенного BLE, то купите для него адаптер с версией Bluetooth не ниже 4.</p>
            <p>
                2. Включите IoT устройство, подождите, пока оно загрузится (около 15 сек), затем нажмите и отпустите кнопку включения Bluetooth.
                Для этого обычно используется скрепка, которой нажимается кнопка через отверстие в корпусе устройства.</p>
            <p>
                3. Нажмите кнопку "Подключиться":</p>
            <button onClick={() => connectButton()}>Подключиться</button>
            <p> 4. В появившемся окне найдите маяк IoT устройства "RealIoT ...".
                Выберите его и нажмите "Pair". Если маяк не появился, выключите и включите снова IoT устройство и
                затем Bluetooth на нем, как описано выше.</p>

            <h3>Параметры сети Wi-Fi</h3>

            <p style={{ marginBottom: '-5px', }}>Точка доступа WiFi:</p>
            <input type="text" id="ssid" name="inputField1" value={ssid} onChange={handleSsidChange} />

            <p style={{ marginBottom: '-5px', }}>Пароль WiFi:</p>
            <input type={isPasswordVisible ? 'text' : 'password'} id="passw" name="inputField2" value={password} onChange={handlePasswordChange} />

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'left', marginBottom: '5px' }}>
                <label style={{ display: 'inline-flex', alignItems: 'left' }}>
                    <input type="checkbox" checked={isPasswordVisible} onChange={togglePasswordVisibility}
                        style={{ marginRight: '10px', marginTop: '3px', flex: '1' }}
                    />
                    Показать пароль
                </label>
            </div>

            <p style={{ marginBottom: '-5px', }}>Вебсайт по умолчанию (редактировать можно только по согласованию с разработчиком):</p>
            <div
                style={{
                    width: '100%', display: 'flex',
                    flexDirection: 'row', // Horizontal layout
                    justifyContent: 'space-around', // Evenly spaced buttons
                    padding: '5px', paddingBottom: `calc(40px + env(safe-area-inset-bottom))`, // Adjust for safe area inset
                    width: 'calc(100% - 10px)',
                }}
            >
                <input type="text" id="website" name="inputField3" value={website} onChange={handleWebsiteChange}
                    readOnly={!isWebsiteEditable} style={{
                        backgroundColor: !isWebsiteEditable ? 'lightgray' : 'white',
                        color: 'black',
                    }} />

                <button
                    onClick={toggleWebsiteEditability}
                >
                    {isWebsiteEditable ? 'Отключить редактирование' : 'Разрешить редактирование адреса вебсайта'}
                </button>
            </div>
            <button onClick={sendData}>Отправить</button>
            <p>
                После подключения к WiFi устройство IoT автоматически отключает свой Bluetooth.</p>

            <h3>Ответ устройства:</h3>
            <div style={{ marginLeft: '5px', textAlign: 'left' }}>
                <pre id="log"></pre>
            </div>
            <button onClick={closewifipopup}>Закрыть</button>
        </div>
    );
}

export default DeviceManagerPage;
